module.exports = __webpack_public_path__ + "static/img/xjpt.fd87739.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xjpt.jpg
// module id = 80sv
// module chunks = 4